import Constants from "../../Constants";
import { toaster } from "../../utils/toast";
import useAxios from "../../hooks/useAxios";
import { confirm } from "../../utils/swal";
import useListPage from "../../hooks/useListPage";

const useTeams = () => {
    const { postData, deleteData } = useAxios();

    const {
        list: teamsList,
        selectedItem: selectedTeam,
        isFormSubmitting,
        setIsFormSubmitting,
        resetValue,
        refetch: fetchTeams,
        handleSearchChange,
        isLoading,
        handleEdit,
        limit,
        setLimit,
        totalCount,
        totalPages,
        currentPage,
        setCurrentPage,
        isShowModal,
        setIsShowModal,
        closeModal,
    } = useListPage({ fetchUrl: Constants.ApiUrl.team.getTeams, responseKey: "teams" });

    const onConfirmDelete = async (teamId) => {
        const errMsg = "There is Some Error Please Try again Later";
        if (!teamId) {
            toaster({ message: errMsg, success: false });
            return;
        }
        try {
            const { success, message } = await deleteData(`${Constants.ApiUrl.team.deleteTeam}/${teamId}`);
            toaster({ message, success });
        } catch (error) {
            toaster({ message: error?.message || errMsg, success: false });
        } finally {
            fetchTeams();
        }
    };

    const handleDelete = async (team) => {
        const result = await confirm({ html: "you want to delete this team? This action cannot be undone.", showCancelButton: true, confirmButtonText: "Yes" });
        if (result.isConfirmed) onConfirmDelete(team?._id);
    };

    const handleSubmitForm = async (formData) => {
        try {
            setIsFormSubmitting(true);
            const { success, message } = await postData(Constants.ApiUrl.team.add, formData);
            if (success) {
                resetValue();
                toaster({ message, success });
                fetchTeams();
            } else {
                toaster({ message: message || "Request Failed Please Try Again Later", success: false });
            }
        } catch (error) {
            toaster({ message: error.message || "Request Failed Please Try Again Later", success: false });
        } finally {
            setIsFormSubmitting(false);
        }
    };

    const onSubmit = (formData) => {
        if (selectedTeam) {
            handleSubmitForm({ ...formData, id: selectedTeam._id });
        } else {
            handleSubmitForm(formData);
        }
    };

    const openModal = () => setIsShowModal(true);

    return {
        handleSearchChange,
        openModal,
        handleEdit,
        handleDelete,
        isLoading,
        teamsList,
        limit,
        setLimit,
        totalCount,
        totalPages,
        currentPage,
        setCurrentPage,
        isShowModal,
        closeModal,
        onSubmit,
        isFormSubmitting,
        selectedTeam,
    };
};

export default useTeams;
